import { Expose } from 'class-transformer';
import { Feature, GeoJsonProperties, Point } from 'geojson';

import { ExposeRawData } from '@lib/common/decorators';
import { SnModel } from '@lib/common/models';

export class SnLayerObject extends SnModel {
  @Expose() public id: string;
  @Expose() public name: string;
  @Expose() @ExposeRawData() public geometry: Point;
  @Expose() @ExposeRawData() public properties: GeoJsonProperties;
  @Expose() @ExposeRawData() public locationUpdatedTimestamp?: any;
  @Expose() @ExposeRawData() public updatedTimestamp?: any;

  constructor(data: any = {}) {
    super();
    this.fromJSON(data);
  }

  public toGeoJSON(): Feature<Point> {
    return {
      type: 'Feature',
      id: this.id,
      geometry: this.geometry,
      properties: {
        name: this.name,
        ...this.properties,
      },
    };
  }
}
